import { useState } from "react";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Settings, KeyRound, Loader2, UserCircle } from "lucide-react";

export default function SettingsPage() {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw !== confirm) {
      toast.error("Yeni şifreler eşleşmiyor");
      return;
    }
    if (nw.length < 6) {
      toast.error("Yeni şifre en az 6 karakter olmalı");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Şifre başarıyla değiştirildi 🔐");
      setCur(""); setNw(""); setConfirm("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Şifre değiştirilemedi");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-5 ela-fade-in max-w-xl" data-testid="settings-page">
      <div>
        <div className="flex items-center gap-2 text-slate-500 text-xs uppercase tracking-wider font-semibold">
          <Settings className="w-3.5 h-3.5" /> Ayarlar
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 mt-1">Hesap Ayarları</h1>
      </div>

      <Card className="p-5 rounded-2xl border-slate-200">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-2xl bg-rose-100 flex items-center justify-center text-2xl">
            {user?.avatar_emoji || <UserCircle className="w-6 h-6 text-rose-500" />}
          </div>
          <div>
            <div className="font-heading font-semibold text-slate-900">{user?.full_name}</div>
            <div className="text-xs text-slate-500">{user?.email}</div>
            <div className="text-[10px] text-slate-400 mt-0.5 uppercase tracking-wider">
              {user?.role === "student" ? "Öğrenci" : "Veli"}
            </div>
          </div>
        </div>
      </Card>

      <Card className="p-5 rounded-2xl border-slate-200">
        <div className="flex items-center gap-2 mb-4">
          <KeyRound className="w-4 h-4 text-[#FF6B6B]" />
          <h3 className="font-heading font-semibold text-slate-900">Şifre Değiştir</h3>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label htmlFor="cur" className="text-slate-700">Mevcut Şifre</Label>
            <Input id="cur" type="password" required value={cur} onChange={(e) => setCur(e.target.value)}
              data-testid="cur-pw-input" className="rounded-xl h-11" />
          </div>
          <div>
            <Label htmlFor="nw" className="text-slate-700">Yeni Şifre</Label>
            <Input id="nw" type="password" required minLength={6} value={nw} onChange={(e) => setNw(e.target.value)}
              data-testid="new-pw-input" className="rounded-xl h-11" />
          </div>
          <div>
            <Label htmlFor="confirm" className="text-slate-700">Yeni Şifre (Tekrar)</Label>
            <Input id="confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
              data-testid="confirm-pw-input" className="rounded-xl h-11" />
          </div>
          <Button type="submit" disabled={busy}
            data-testid="change-pw-submit"
            className="w-full bg-[#FF6B6B] hover:bg-[#FF5252] rounded-xl h-11">
            {busy ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Değiştiriliyor…</> : "Şifreyi Güncelle"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
